import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CaixaService } from 'app/service/caixa/caixa.service';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';
import * as CryptoJS from 'crypto-js';
import {EventEmitterService} from "../../../service/event-emitter-service";

@Component({
  selector: 'app-relatorio-solicitacao-realocacao',
  templateUrl: './relatorio-solicitacao-realocacao.component.html',
  styleUrls: ['./relatorio-solicitacao-realocacao.component.scss']
})
export class RelatorioSolicitacaoRealocacaoComponent implements OnInit {

  public solicitacaoId;
  public deData;
  public solicitacao;
  public dateTime;
  public caixas;
  loading = false;

  constructor(
    private solicitacaoService: SolicitacaoService,
    private route: ActivatedRoute) {
    EventEmitterService.get('isPrintPage').emit(true);
    this.route.params.subscribe(params => this.solicitacaoId = params['id']);
    this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.solicitacaoId), 'pcdoc');
    this.solicitacaoId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
   }

  ngOnInit() {
    this.getSolicitacao(this.solicitacaoId);
    let date = new Date();
    this.dateTime = date.toLocaleString('pt-BR');
    this.getCaixasRealocadas(this.solicitacaoId);
  }

  getSolicitacao(solicitacaoId) {
    this.solicitacaoService.getSolicitacao(solicitacaoId).subscribe(data => {
      this.solicitacao = data;
      console.log(this.solicitacao);
    }, err => {
      console.error(err);
    });
  }

  getCaixasRealocadas(solicitacaoId) {
    this.solicitacaoService.relatorioCaixasRealocadas(solicitacaoId).subscribe(data => {
      console.log(data);
      this.caixas = data;
    }, err => {
      console.error(err);
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/relatorio-solicitacao-realocacao/relatorio-solicitacao-realocacao.component.ts